module.exports = __webpack_public_path__ + "img/scientificImg01.6ff5a747.png";